import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=47ba64e7&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=47ba64e7&lang=scss&scoped=true"
import style1 from "./edit.vue?vue&type=style&index=1&id=47ba64e7&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba64e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ba64e7')) {
      api.createRecord('47ba64e7', component.options)
    } else {
      api.reload('47ba64e7', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=47ba64e7&scoped=true", function () {
      api.rerender('47ba64e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_text/edit.vue"
export default component.exports